










import { computed, defineComponent, toRefs } from '@nuxtjs/composition-api'
import Fieldset from '~/components/car/classifieds/form/fieldsets/handlers/Fieldset.vue'
import BaseFieldsetMixin from '~/components/car/classifieds/form/fieldsets/handlers/BaseFieldsetMixin.vue'

export default defineComponent({
  components: { Fieldset },
  mixins: [BaseFieldsetMixin],
  setup(props) {
    const { fields } = toRefs(props)
    const filteredFields = computed(() =>
      fields.value.filter(f => f.name !== 'is_financed')
    )

    return {
      filteredFields
    }
  }
})
